import { yupResolver } from "@hookform/resolvers/yup/dist/yup";
import { useForm } from "react-hook-form";
import VehicleCategoryForm from "./VehicleCategoryForm";

//@ts-ignore
import { FormLayout } from "@careinfo/layout";
import { productTypeValidationForm } from "../../utils/validationSchemas";

const CreateVehicleCategory = (props: any) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
    setError,
  } = useForm<any>({
    resolver: yupResolver(productTypeValidationForm),
  });
  const { handleCreate, isLoading } = props;
  return (
    <FormLayout
      handleSubmit={handleSubmit}
      handleFormSubmit={handleCreate}
      setError={setError}
      buttonLabel={"Create"}
      isLoading={isLoading}
    >
      <VehicleCategoryForm
        errors={errors}
        register={register}
      />
    </FormLayout>
  );
};

export default CreateVehicleCategory;
